import React from 'react';
import { X } from 'lucide-react';
import { Button } from './Button';

export interface BulkAction {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  loading?: boolean;
}

interface BulkActionBarProps {
  count: number;
  onClear: () => void;
  actions: BulkAction[];
}

export function BulkActionBar({ count, onClear, actions }: BulkActionBarProps) {
  if (count === 0) return null;

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
      padding: '0.75rem 1.25rem',
      background: 'var(--glass-bg-card)',
      backdropFilter: 'blur(16px) saturate(140%)',
      WebkitBackdropFilter: 'blur(16px) saturate(140%)',
      border: '1px solid rgba(79,152,163,0.25)',
      borderRadius: 'var(--radius-card)',
      flexWrap: 'wrap',
    }}>
      <span style={{
        fontSize: 'var(--text-sm)',
        fontWeight: 600,
        color: 'var(--color-primary)',
        flexShrink: 0,
      }}>
        {count} {count === 1 ? 'elemento selezionato' : 'elementi selezionati'}
      </span>

      <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', flex: 1 }}>
        {actions.map((action, i) => (
          <Button
            key={i}
            size="sm"
            variant={action.variant ?? 'secondary'}
            onClick={action.onClick}
            loading={action.loading}
            icon={action.icon}
          >
            {action.label}
          </Button>
        ))}
      </div>

      <button
        onClick={onClear}
        aria-label="Deseleziona tutto"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: 'var(--color-text-muted)',
          padding: '0.25rem',
          borderRadius: 'var(--radius-interactive)',
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
          transition: 'color var(--transition-interactive)',
        }}
        onMouseEnter={e => (e.currentTarget.style.color = 'var(--color-text)')}
        onMouseLeave={e => (e.currentTarget.style.color = 'var(--color-text-muted)')}
      >
        <X size={16} />
      </button>
    </div>
  );
}
